import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { download as downloadIcon } from 'react-icons-kit/ikons/download';
import { documentIcon } from 'react-icons-kit/ikons/documentIcon';
import Icon from 'react-icons-kit';
import { renderFileName } from '../../../utils/CommonFunctions';
import { handleImageDownload } from '../../../utils/HelperFunctions';
import SimpleReactLightbox from 'simple-react-lightbox';
import { SRLWrapper } from 'simple-react-lightbox';

const LightBoxContainer = ({ children }) => {
    return (
        <SimpleReactLightbox>
            <SRLWrapper
                options={{
                    thumbnails: { showThumbnails: false },
                    buttons: {
                        showAutoplayButton: false,
                        showNextButton: false,
                        showPrevButton: false,
                    },
                }}
            >
                {children}
            </SRLWrapper>
        </SimpleReactLightbox>
    );
};
const AttachmentItem = ({ attachment }) => {
    const imgRef = useRef();
    const anchorRef = useRef();

    const handleDownloadIconClick = (event, attachment) => {
        handleImageDownload(attachment);
        event.stopPropagation();
    };

    return (
        <div onClick={() => anchorRef.current.click()} className="eAttachmentContainer">
            <a ref={anchorRef} href={attachment.url}>
                {attachment.web_thumbnail_url === '' ? (
                    <Icon icon={documentIcon} size={40} className="eAttachmentNoPreviewIcon" />
                ) : (
                    <img
                        ref={imgRef}
                        alt={attachment.name || 'attachment'}
                        className="eAttachmentImage"
                        src={attachment.web_thumbnail_url}
                    />
                )}
            </a>
            <span className="eAttachmentFilename">
                {renderFileName(attachment.name, attachment.type)}
            </span>
            <Icon
                onClick={e => handleDownloadIconClick(e, attachment)}
                icon={downloadIcon}
                size={24}
                className="eAttachmentDownloadIcon"
            />
        </div>
    );
};

const isImageAttachment = attachment => attachment.type !== 'application/pdf';
const isPdfAttachment = attachment => attachment.type === 'application/pdf';

const AttachmentsView = ({ attachments }) => {
    return (
        <div className="eAttachmentsContainer">
            <LightBoxContainer>
                {attachments.filter(isImageAttachment).map(attachment => (
                    <AttachmentItem key={attachment.id} attachment={attachment} />
                ))}
            </LightBoxContainer>
            {attachments.filter(isPdfAttachment).map(attachment => (
                <AttachmentItem key={attachment.id} attachment={attachment} />
            ))}
        </div>
    );
};

AttachmentsView.propTypes = {
    attachments: PropTypes.array,
};
AttachmentsView.defaultProps = {
    attachments: [],
};
export default AttachmentsView;
